import * as z from "zod";

import { partnerSummarySchema } from "./shared";

/** Fails with a 409 when another partner has the name. */
export const createPartner = {
  name: "createPartner" as const,
  input: z.object({ name: z.string().trim().min(1).max(200) }),
  output: z.object({ partner: partnerSummarySchema }),
};
